import React from "react";
import styled from "styled-components";
import { Box, ButtonBase, TextField, Typography } from "@mui/material";

export const Container = styled(Box)`
  && {
    position: absolute;
    left: 50%;
    width: 50%;
    height: 100%;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 600;
    font-size: 48px;
    line-height: 65px;
    color: #000000;
  }
`;

export const InputLabel = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }
`;

export const InputTextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
      width: 480px;
      height: 40px;
      background: #eaeef2;
      border-radius: 10px;
      & > fieldset {
        border: none;
      }
    }
  }
`;

export const SigninButton = styled(ButtonBase)`
  && {
    width: 175px;
    height: 50px;
    background: #f2753b;
    border-radius: 5px;
    text-transform: capitalize;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
    margin: 30px auto;
  }
`;

export const RegisterLabelLink = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    text-decoration: none;
    margin: auto;
    color: ${(props) => props.linkColor || "#000000"};
  }
`;

export const FrgtPswdLink = styled(Typography)`
  && {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #2a94f4;
    text-decoration: none;
    position: relative;
    left: 60%;
  }
`;

export const AuthTextField = ({ value, setValue, type }) => {
  return (
    <InputTextField
      required
      value={value}
      onChange={(e) => setValue(e.target.value)}
      type={type || "text"}
    />
  );
};
